/**
 * Created by andrey on 02.02.2021.
 */

cc.getCenter = function (points) {
    if (!points || points.length === 0) {
        return;
    }

    let x = 0, y = 0;
    points.forEach((pos) => {
        x += pos.x;
        y += pos.y;
    });
    return cc.p(x / points.length, y / points.length);
};

cc.getCenterPoint = function (points) {
    if (!points || points.length === 0) {
        return;
    }

    let x = 0, y = 0;
    points.forEach((pos) => {
        x += pos.x;
        y += pos.y;
    });
    const center = cc.p(x / points.length, y / points.length);

    let res = points[0];
    let minDist = cc.pDistance(res, center);
    points.forEach((p) => {
        const dist = cc.pDistance(p, center);
        if (dist < minDist) {
            res = p;
            minDist = dist;
        }
    });
    return res;
};

cc.getDistanceChebyshev = function (p1, p2) {
    return Math.max(Math.abs(p1.x - p2.x), Math.abs(p1.y - p2.y));
};

cc.rectScale = function (rect, scale) {
    return cc.rect(
        rect.x + rect.width / 2 * (1 - scale),
        rect.y + rect.height / 2 * (1 - scale),
        rect.width * scale,
        rect.height * scale
    );
};

cc.rectGetCenter = function (rect) {
    return cc.p(rect.x + rect.width / 2, rect.y + rect.height / 2);
};

cc.padding = function (top, right, bottom, left) {
    const predicate = (value) => typeof value === "number";

    if (typeof right === "object") {
        const p1 = cc.padding(top), p2 = right;
        right = [p2.right, p2.x, p1.right].find(predicate);
        bottom = [p2.bottom, p2.y, p1.bottom].find(predicate);
        left = [p2.left, p2.x, p1.left].find(predicate);
        top = [p2.top, p2.y, p1.top].find(predicate);
    } else if (right === undefined && typeof top === "number") {
        right = top;
        bottom = top;
        left = top;
    } else if (right === undefined && typeof top === "object") {
        right = [top.right, top.x].find(predicate);
        bottom = [top.bottom, top.y].find(predicate);
        left = [top.left, top.x].find(predicate);
        top = [top.top, top.y].find(predicate);
    } else if (bottom === undefined && right !== undefined && top !== undefined) {
        bottom = top;
        left = right;
    }

    return {
        top: top || 0,
        right: right || 0,
        bottom: bottom || 0,
        left: left || 0
    };
};

cc.rectAddPadding = function (rect, padding) {
    return cc.rect(rect.x - padding.left, rect.y - padding.bottom, rect.width + padding.left + padding.right, rect.height + padding.bottom + padding.top);
};

cc.rectSubPadding = function (rect, padding) {
    return cc.rect(
        rect.x + padding.left,
        rect.y + padding.bottom,
        Math.max(rect.width - padding.left - padding.right, 0),
        Math.max(rect.height - padding.bottom - padding.top, 0)
    );
};

cc.multPadding = function (padding, factor) {
    return {
        top: padding.top * factor,
        right: padding.right * factor,
        bottom: padding.bottom * factor,
        left: padding.left * factor
    };
};

cc.paddingSubPadding = function (padding1, padding2) {
    return cc.mergePaddings([
        cc.paddingAddPadding(padding1, cc.multPadding(padding2, -1)),
        cc.padding()
    ]);
};

cc.paddingAddPadding = function (padding1, padding2) {
    return {
        top: padding1.top + padding2.top,
        right: padding1.right + padding2.right,
        bottom: padding1.bottom + padding2.bottom,
        left: padding1.left + padding2.left
    };
};

cc.paddingsEqual = function (padding1, padding2) {
    return padding1.left === padding2.left
        && padding1.right === padding2.right
        && padding1.top === padding2.top
        && padding1.bottom === padding2.bottom;
};

cc.mergePaddings = function (paddings) {
    return paddings.reduce((maxPadding, padding) => ({
        top: Math.max(maxPadding.top, padding.top), 
        right: Math.max(maxPadding.right, padding.right),
        bottom: Math.max(maxPadding.bottom, padding.bottom),
        left: Math.max(maxPadding.left, padding.left)
    }), paddings[0] || cc.padding());
};

cc.rotatePadding = function (padding) {
    return cc.padding(
        padding.left,
        padding.top,
        padding.right,
        padding.bottom
    );
};

cc.rectUnionPadding = function (rect, otherRect) {
    const union = cc.rectUnion(rect, otherRect);
    return cc.padding(
        union.y + union.height - rect.y - rect.height,
        union.x + union.width - rect.x - rect.width,
        rect.y - union.y,
        rect.x - union.x
    );
};

cc.nearestToRect = function (rect, point) {
    let x, y;

    if (point.x <= rect.x) {
        x = rect.x;
    } else if (point.x >= rect.x + rect.width) {
        x = rect.x + rect.width;
    } else {
        x = point.x;
    }

    if (point.y <= rect.y) {
        y = rect.y;
    } else if (point.y >= rect.y + rect.height) {
        y = rect.y + rect.height;
    } else {
        y = point.y;
    }

    return cc.p(x, y);
};

cc.convertRectToNodeSpace = function (node, rect) {
    const transform = node.getWorldToNodeTransform();
    return cc.rectApplyAffineTransform(rect, transform);
};

cc.rectClampToRect = function (rect, availableRect) {
    rect = cc.rect(rect.x, rect.y, rect.width, rect.height);

    if (rect.x < availableRect.x) {
        rect.x = availableRect.x;
    }

    if (rect.y < availableRect.y) {
        rect.y = availableRect.y;
    }

    if (rect.x + rect.width > availableRect.x + availableRect.width) {
        rect.x = availableRect.x + availableRect.width - rect.width;
    }

    if (rect.y + rect.height > availableRect.y + availableRect.height) {
        rect.y = availableRect.y + availableRect.height - rect.height;
    }

    return rect;
};
